import React, { Component } from "react";
import TrackVisibility from "react-on-screen";
import { Col, Row } from "antd";
import cn from "classnames";
import { FormattedMessage } from "react-intl";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import AnimatedList from "../LandingAnimatedList";
import messages from "./messages";

import Wrapper from "../LandingBlockWrapper/BlockWrapper";
import icon1 from "../../assets/images/gallery/Camera02_background.png";
import icon2 from "../../assets/images/gallery/Camera03_background.png";
import icon3 from "../../assets/images/gallery/Camera04_background.png";
import icon4 from "../../assets/images/gallery/Camera05_background.png";
import icon5 from "../../assets/images/gallery/Camera06_background.png";
import icon6 from "../../assets/images/gallery/Camera07_background.png";
import icon7 from "../../assets/images/gallery/Camera02_background.png";

import icon1Big from "../../assets/images/desktop/Camera02_background.png";
import icon2Big from "../../assets/images/desktop/Camera03_background.png";
import icon3Big from "../../assets/images/desktop/Camera04_background.png";
import icon4Big from "../../assets/images/desktop/Camera05_background.png";
import icon5Big from "../../assets/images/desktop/Camera06_background.png";
import icon6Big from "../../assets/images/desktop/Camera07_background.png";
import icon7Big from "../../assets/images/desktop/Camera02_background.png";

const listData = [
	{
		title: <FormattedMessage {...messages.title1} />,
		icon: icon1,
		iconBig: icon1Big,
	},
	{
		title: <FormattedMessage {...messages.title2} />,
		icon: icon2,
		iconBig: icon2Big,
	},
	{
		title: <FormattedMessage {...messages.title3} />,
		icon: icon3,
		iconBig: icon3Big,
		
	},
	{
		title: <FormattedMessage {...messages.title4} />,
		icon: icon4,
		iconBig: icon4Big,
	},
	{
		title: <FormattedMessage {...messages.title5} />,
		icon: icon5,
		iconBig: icon5Big,
	},
	{
		title: <FormattedMessage {...messages.title6} />,
		icon: icon6,
		iconBig: icon6Big,
	},
	{
		title: <FormattedMessage {...messages.title7} />,
		icon: icon7,
		iconBig: icon7Big,
	}
];

const List = ({ currentIndex, stopTimer, startTimer, listData }) => {
	return (
		<ul>
			{listData.map((m, index) => {
					const selected = currentIndex === index;
					return (
						<li
							onMouseEnter={(e) => stopTimer(index)}
							onMouseLeave={startTimer}
							className={cn(selected && "active")}
							key={index}
						>
							{m.title}
							<div className="mobileView">
								{selected && <TransitionGroup>
									<CSSTransition
										appear={true}
										classNames="mobileAnimate"
										key={`images_${index}`}
										timeout={{
											enter: 500,
											exit: 500
										}}>
										<div>
											<img src={listData[currentIndex].icon} alt={m.title}/>
										</div>
									</CSSTransition>
								</TransitionGroup>}
							</div>
						</li>
					);
				}
			)}
		</ul>
	);
};

class TechSpecs extends Component{
	constructor() {
		super();
		this.state = {
			currentIndex: 0,
		};
	}
	
	onIndexChanged = (index) => {
		this.setState({
			currentIndex: index
		});
	};
	
	render() {
		const { currentIndex } = this.state;
		const imgBig = listData[currentIndex].iconBig;
		return (
			<Wrapper className="TechSpecs">
				<Row>
					<Col sm={24}>
						<p>
							<FormattedMessage {...messages.title} />
						</p>
						<TrackVisibility partialVisibility>
							<AnimatedList
								listDataLength={listData.length}
								onIndexChanged={(index) => this.onIndexChanged(index)}
							>
								<List listData={listData}/>
							</AnimatedList>
						</TrackVisibility>
					</Col>
				</Row>
				<TransitionGroup className="desktopView">
					<CSSTransition
						appear={true}
						classNames="desktopAnimate"
						key={`images_${currentIndex}`}
						timeout={{
							enter: 500,
							exit: 500
						}}>
						<div
							className="desktopImage"
							style={{ backgroundImage: `url(${imgBig})` }}>
						</div>
					</CSSTransition>
				</TransitionGroup>
			</Wrapper>
		);
	}
}

export default TechSpecs;


// WEBPACK FOOTER //
// ./src/components/LandingTechSpecs/TechSpecs.js